import { createContentHook } from './createContentHook';
import type { AboutNewsroomContent } from '../types/AboutNewsroomContent';

export const useAboutNewsroomContent = createContentHook<AboutNewsroomContent>('/About/Newsroom');
